import { useMemo } from 'react'

import {
  CreateAIChatFallbackContactMutation,
  CreateAIChatFallbackContactMutationVariables,
  DeleteAIChatFallbackContactMutation,
  DeleteAIChatFallbackContactMutationVariables,
  GetAIChatFallbackContactsQuery,
  GetAIChatFallbackContactsQueryVariables,
  UpdateAIChatFallbackContactMutation,
  UpdateAIChatFallbackContactMutationVariables,
} from 'types/graphql'

import { useMyOrgId } from 'src/layouts/AppStateContextLayout/utils'
import { QueryKey, useMutation, useQuery } from 'src/utils/queryClient'

const GetAIChatFallbackContacts = gql`
  query GetAIChatFallbackContactsQuery($organizationId: Int!) {
    getAIChatFallbackContacts(organizationId: $organizationId) {
      ...AIChatFallbackContactFragment
    }
  }
`

export const useGetAIChatFallbackContactsQuery = () => {
  const organizationId = useMyOrgId()
  const { data, ...rest } = useQuery<
    GetAIChatFallbackContactsQuery,
    GetAIChatFallbackContactsQueryVariables
  >({
    queryKey: [QueryKey.GetAIChatFallbackContacts, organizationId],
    queryDocument: GetAIChatFallbackContacts,
    variables: { organizationId: organizationId ?? -1 },
    enabled: !!organizationId,
  })
  const aiChatFallbackContacts = useMemo(() => data?.getAIChatFallbackContacts || [], [data])
  return { ...rest, aiChatFallbackContacts }
}

const CreateAIChatFallbackContact = gql`
  mutation CreateAIChatFallbackContactMutation($input: AIChatFallbackContactInput!) {
    createAIChatFallbackContact(input: $input) {
      ...AIChatFallbackContactFragment
    }
  }
`

export const useCreateAIChatFallbackContactMutation = () => {
  return useMutation<
    CreateAIChatFallbackContactMutation,
    CreateAIChatFallbackContactMutationVariables
  >({
    mutationDocument: CreateAIChatFallbackContact,
  })
}

const UpdateAIChatFallbackContact = gql`
  mutation UpdateAIChatFallbackContactMutation($id: Int!, $input: AIChatFallbackContactInput!) {
    updateAIChatFallbackContact(id: $id, input: $input) {
      ...AIChatFallbackContactFragment
    }
  }
`

export const useUpdateAIChatFallbackContactMutation = () => {
  return useMutation<
    UpdateAIChatFallbackContactMutation,
    UpdateAIChatFallbackContactMutationVariables
  >({
    mutationDocument: UpdateAIChatFallbackContact,
  })
}

const DeleteAIChatFallbackContact = gql`
  mutation DeleteAIChatFallbackContactMutation($id: Int!) {
    deleteAIChatFallbackContact(id: $id) {
      ...AIChatFallbackContactFragment
    }
  }
`

export const useDeleteAIChatFallbackContactMutation = () => {
  return useMutation<
    DeleteAIChatFallbackContactMutation,
    DeleteAIChatFallbackContactMutationVariables
  >({
    mutationDocument: DeleteAIChatFallbackContact,
  })
}
